export default {
  description: 'Use a title to label multiple procedures started at the same time.',
  label: 'Title',
  missingInfo: 'Information is missing',
  missingInfoDescription: 'Please select targets before accessing this page.',
  placeholder: 'e.g. May 2026 batch',
  requirementOptional: ' (Optional)',
  requirementRequired: ' (Required)',
  title: '{{packageTypeName}} - Enter title'
};